import { render, staticRenderFns } from "./parcel-detail-block-address.vue?vue&type=template&id=41d76bfa"
import script from "./parcel-detail-block-address.vue?vue&type=script&lang=ts"
export * from "./parcel-detail-block-address.vue?vue&type=script&lang=ts"
import style0 from "./parcel-detail-block-address.vue?vue&type=style&index=0&id=41d76bfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports